import { render, staticRenderFns } from "./InicioPage.vue?vue&type=template&id=65c35a9e&scoped=true"
import script from "./InicioPage.vue?vue&type=script&lang=js"
export * from "./InicioPage.vue?vue&type=script&lang=js"
import style0 from "./InicioPage.vue?vue&type=style&index=0&id=65c35a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c35a9e",
  null
  
)

export default component.exports